import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontLeftSideshaftProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function FrontLeftSideshaft(props: FrontLeftSideshaftProps) {
  return (
    <svg
      width="30"
      height="57"
      viewBox="0 0 30 57"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{bottom: 147, left: 267}}
      onClick={props.onClick}
    >
      <path
        d="M3 9H7C7 9 5 8.99998 5 11C5 13 7 13 7 13H9C9 13 7 13 7 15C7 17 9 17 9 17H11C11 17 9 17 9 19C9 20.75 10.5312 20.9687 10.9141 20.9961L11 21V56H19V21C19 21 21 21 21 19C21 17 19 17 19 17H21C21 17 23 17 23 15C23 13 21 13 21 13H23C23 13 25 13 25 11C25 8.99998 23 9 23 9H27C27 9 29 9.00002 29 7V1H1V7C1 9.00002 3 9 3 9Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M19.0002 21L19 56H11L11.0002 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M19 21H15H11C11 21 9 21 9 19C9 17 11 17 11 17H15H19C19 17 21 17 21 19C21 21 19 21 19 21Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M21 17H15H9C9 17 7 17 7 15C7 13 9 13 9 13H15H21C21 13 23 13 23 15C23 17 21 17 21 17Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 13H15H7C7 13 5 13 5 11C5 8.99997 7 9 7 9H15H23C23 9 25 8.99997 25 11C25 13 23 13 23 13Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M27 9H15H3C3 9 1 9 1 6.99998V0.999985H29V6.99998C29 9 27 9 27 9Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
